const COST_CODE_MAP: Record<string, string> = {
  "0": "M",
  "1": "V",
  "2": "I",
  "3": "B",
  "4": "G",
  "5": "E",
  "6": "O",
  "7": "R",
  "8": "A",
  "9": "D",
};

export const formatCostCode = (value: number | string | null | undefined) => {
  if (value === null || value === undefined || value === "") {
    return "";
  }

  const normalizedValue = String(value).trim();
  const numericValue = Number(normalizedValue);

  if (Number.isNaN(numericValue)) {
    return normalizedValue;
  }

  const sign = numericValue < 0 ? "-" : "";
  const absoluteValue = Math.abs(numericValue);
  const [whole, decimal = ""] = absoluteValue.toFixed(3).split(".");

  const encodedWhole = Array.from(whole).map((char) => COST_CODE_MAP[char] ?? char).join("");
  const encodedDecimal = decimal
    ? Array.from(decimal).map((char) => COST_CODE_MAP[char] ?? char).join("")
    : "";

  return `${sign}${encodedWhole}${encodedDecimal ? `.${encodedDecimal}` : ""}`;
};
